import React, { Component } from 'react';
import { Table } from 'react-bootstrap/lib';
import Api from './../../Global/Modules/Api';

const FETCH_URL = 'api/members'

class TablesControleResults extends Component {
    constructor() {
        super();
        this.state = {
            searchError: 'none',
            members: [],
            displayTable: 'none',
            emptyTable: 'none',
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0
            }
        }
        this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount() {
        var searchword = { name: this.props.srch };
        var word = this.props.srch;
        if (word.length < 3) {
            this.setState({ searchError: 'block' })
            return false;
        } else {
            this.setState({ searchError: 'none' })
        }
        Api.PostTableApi(FETCH_URL, searchword, this.props.history, this.handleClick).then(response => {
            if (response === undefined || response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            if (response === undefined) {
                return undefined;
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            if (objectData === undefined || objectData.members.length === 0) {
                let result = [<tr key="0"><td colSpan='4'>Geen resultaten gevonden voor: {word}</td></tr>]
                this.setState({ members: result })
            } else {
                let members = objectData.members.map((item, index) => {
                    return <tr key={index}>
                        <td>{item.name}</td>
                        <td>{item.city}</td>
                        <td>{item.status}</td>
                    </tr>
                })
                this.setState({ members: members });
            }
        })

    }

    handleClick(e) {
        var searchword = { name: this.props.srch };
        var word = this.props.srch;
        if (word.length < 3) {
            this.setState({ searchError: 'block' })
            return false;
        } else {
            this.setState({ searchError: 'none' })
        }
        const FETCH_URL_PAG = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        Api.PostTableApi(FETCH_URL_PAG, searchword, this.props.history, this.handleClick).then(response => {
            if (response === undefined || response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            if (response === undefined) {
                return undefined;
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            if (objectData === undefined || objectData.members === undefined) {
                let result = [<tr key="0"><td colSpan='4'>No results found for: {word}</td></tr>]
                this.setState({ members: result })
            } else {
                let members = objectData.members.map((item, index) => {
                    return <tr key={index}>
                        <td>{item.name}</td>
                        <td>{item.city}</td>
                        <td>{item.status}</td>
                    </tr>
                })
                this.setState({ members: members });
            }
        })
    }

    render() {
        return (
            <div>
                <h4>Constructeurs overzicht</h4>
                <div style={{ display: this.state.displayTable }}>
                    <div>Resultaten  {(this.state.pagination.pageSize == '0' || this.state.pagination.pageSize > this.state.pagination.totalCount) ? this.state.pagination.totalCount : this.state.pagination.pageSize} van {this.state.pagination.totalCount}</div>

                    <Table responsive>
                        <thead>
                            <tr>
                                <th>Naam</th>
                                <th>Woonplaats</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.members}
                        </tbody>
                    </Table>
                    <div className="paginationStyling">
                    <div style={{ float: 'left' }}>
                        {this.state.pagination.prevButton}
                    </div>
                    <div style={{ float: 'center' }}>
                        Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                    </div>
                    <div style={{ float: 'right' }}>
                        {this.state.pagination.nextButton}
                    </div>
</div>
                </div>

                <div style={{ display: this.state.searchError, color: 'red' }}>At least 3 characters to search</div>
                <div style={{ display: this.state.emptyTable }}>
                    <br /> <br />
                    Er zijn geen gegevens beschikbaar
                </div>
            </div>

        );
    }
}

export default TablesControleResults;



// WEBPACK FOOTER //
// ./src/components/Global/Modules/TablesControleResults.js